import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://oldpzwjftbpsjvpgxgdv.supabase.co';
const SUPABASE_KEY = 'sb_publishable_Vyov2pAy33aeBtkm4emHBQ_LIjPW0br';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
